import type { CSSProperties } from 'react'
import { Box, FormControl, Stack, Typography } from '@mui/material'
import { useControllerActions } from '../hooks/useControllerActions'
import { useTerritoryDropdownItems } from '../hooks/useTerritoryDropdownItems'
import { useController } from '../hooks/useController'
import { useTexts } from '../hooks/useTexts'
import { SimpleSelect } from '@workwave-tidal/core/components'

const layoutStyle: CSSProperties = { width: '100%' }

export function Body() {
  const texts = useTexts()
  const handlers = useControllerActions()
  const {
    invalid,
    data: { territories, id },
  } = useController()

  const dropdownItems = useTerritoryDropdownItems(territories, id)

  return (
    <Stack direction="column" marginTop={4} style={layoutStyle}>
      <Box mb={2} width="100%">
        <Typography variant="subtitle1" color="text.secondary" sx={{ textTransform: 'uppercase' }}>
          {texts.territoryDropdownTitle}
        </Typography>
      </Box>

      <FormControl sx={{ mb: 4 }} fullWidth>
        <SimpleSelect
          value={id || ''}
          onChange={e => handlers.onTerritoryChange({ id: e.target.value })}
          disabled={!dropdownItems || invalid}
          displayEmpty
          options={
            dropdownItems?.map(item => ({
              value: item.id,
              label: item.label,
            })) || []
          }
          testId="copy-start-end-route-settings-modal-territory-select"
        />
      </FormControl>
    </Stack>
  )
}
